import { render, staticRenderFns } from "./VeriicationDetailsCompanyDocs.vue?vue&type=template&id=7cbe5718&"
import script from "./VeriicationDetailsCompanyDocs.vue?vue&type=script&lang=js&"
export * from "./VeriicationDetailsCompanyDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports